import type { Category, Lang } from "./types";

export const categories: Category[] = [
  { key: "all", zh: "全部", en: "All" },
  { key: "street", zh: "街拍", en: "Street" },
  { key: "landscape", zh: "风景", en: "Landscape" },
  { key: "life", zh: "生活", en: "Life" }
];

export const i18n = {
  zh: {
    siteName: "拾光集",
    siteSub: "Gathered Light",
    range: "2025 - 2026",
    issue: "拾光为集 · 个人影像手记",
    headline: "拾起那些被光掠过的、缓慢而不起眼的寻常一刻。",
    intro: "街角、天气、窗台上的一杯茶，均被轻轻收录于此，留于多年以后翻看。",
    introLines: [
      "街角、天气、窗台上的一杯茶，均被轻轻收录于此，留于多年以后翻看。",
      "把日常里微弱的光、风声与停顿收好，等某个下午再慢慢翻开。"
    ],
    updated: "更新于 2026.05",
    frames: (n: number) => `${n} 帧`,
    admin: "管理",
    dashboard: "仪表盘",
    overview: "总览",
    recentUploads: "最近上传",
    byPrivacy: "按隐私分布",
    byCategory: "按分类分布",
    mediaQueue: "媒资队列",
    navContent: "内容",
    navAccess: "成员",
    navTaxonomy: "分类体系",
    navSystem: "系统",
    dashboardSub: "拾光集 · 内容与媒资概览",
    photosSub: "管理所有上传的影像作品",
    usersSub: "维护登录账户与角色",
    tagsSub: "整理作品标签",
    categoriesSub: "整理作品分类",
    appearance: "外观",
    appearanceSub: "切换前台站点的整体配色",
    themeWarmName: "Warm",
    themeWarmDesc: "暖中性编辑感，适合慢节奏影像日记。",
    themeCoolName: "Cool",
    themeCoolDesc: "克制的白底界面，接近 Apple / Linear 风格。",
    themeBoldName: "Bold",
    themeBoldDesc: "高对比新闻纸感，用红色作为强调。",
    themeApplied: (name: string) => `已切换到 ${name} 主题`,
    siteRangeLabel: "站点年份",
    siteRangeHint: "显示在前台页脚，例如 2025 - 2026。",
    siteRangeSaved: "站点年份已更新",
    heroLabel: "首屏文案",
    heroHint: "前台首屏的小标题、大字标题与打字机循环文案，中英文各一份。",
    heroIssueZh: "小标题（中）",
    heroIssueEn: "小标题（英）",
    heroHeadlineZh: "大字标题（中）",
    heroHeadlineEn: "大字标题（英）",
    heroLinesZh: "打字机文案（中）",
    heroLinesEn: "打字机文案（英）",
    heroLinesHint: "每行一句，循环播放；最多 5 行。",
    heroSaved: "首屏文案已更新",
    welcomeBack: "欢迎回来",
    viewSite: "查看前台",
    accountSection: "账户",
    bulkSelected: (n: number) => `已选 ${n} 张`,
    bulkDelete: "批量删除",
    bulkPrivacy: "批量改隐私",
    bulkTags: "批量打标",
    selectAll: "全选当前页",
    clearSelection: "清空选择",
    invertSelection: "反选",
    appendMode: "追加",
    replaceMode: "替换",
    bulkDeleteConfirm: (n: number) => `确认批量删除 ${n} 张？`,
    photos: "作品",
    users: "用户",
    tags: "标签",
    categoriesAdmin: "分类",
    public: "公开",
    locked: "已加锁",
    private: "私密",
    unlocked: "已解锁",
    passcode: "口令",
    unlock: "解锁",
    close: "关闭",
    prev: "上一张",
    next: "下一张",
    login: "登录",
    logout: "退出",
    email: "邮箱",
    password: "密码",
    site: "前台",
    newPhoto: "新建",
    edit: "编辑",
    recoverUrl: "恢复链接",
    recoveringUrl: "恢复中",
    recoverUrlDone: "已恢复图片链接",
    delete: "删除",
    reset: "重置",
    repairLegacy: "修复历史数据",
    repairLegacyDone: "历史数据已修复",
    save: "保存",
    cancel: "取消",
    total: "总数",
    role: "角色",
    displayName: "显示名",
    createdAt: "创建时间",
    actions: "操作",
    addTag: "新建标签",
    editTag: "编辑标签",
    tagSlug: "Slug",
    tagNameZh: "中文名",
    tagNameEn: "英文名",
    addCategory: "新建分类",
    editCategory: "编辑分类",
    categorySlug: "Slug",
    categoryNameZh: "中文名",
    categoryNameEn: "英文名",
    sortOrder: "排序",
    photoCount: "作品数",
    slugChangeWarning: "改 slug 会让旧分类 URL 失效。",
    newUser: "新建用户",
    editUser: "编辑用户",
    resetPassword: "重置密码",
    newPassword: "新密码",
    owner: "Owner",
    editor: "Editor",
    viewer: "Viewer",
    title: "标题",
    slug: "Slug",
    caption: "说明",
    altText: "替代文本",
    searchPlaceholder: "搜索 slug / 标题 / 地点 / 说明",
    prevPage: "上一页",
    nextPage: "下一页",
    pageOf: (page: number, total: number) => `第 ${page} / ${total} 页`,
    imageUrl: "图片地址",
    location: "地点",
    date: "日期",
    category: "分类",
    privacy: "可见性",
    noFrames: "暂无作品",
    noTags: "暂无标签",
    noCategories: "暂无分类",
    apiSaved: "数据通过 Axum API 保存。",
    footerNote: "拾光为集，轻轻合上。仅与朋友分享，请勿转载。",
    lockedHint: "请输入分享给朋友的口令。",
    lockedPasscodeHint: "提示 · 1234",
    privateTitle: "这一帧是私密的",
    privateOnly: "这一帧是私密的，仅本人可见。",
    presign: "申请上传 URL",
    presignReady: "已生成 Presigned URL",
    uploading: "上传中...",
    uploadDone: "上传完成",
    uploadFailed: "上传失败",
    chooseFile: "选择文件",
    viewOriginal: "查看原图",
    viewFull: "查看高清图",
    fitToScreen: "适应屏幕",
    zoomIn: "放大",
    zoomOut: "缩小",
    rotateLeft: "左旋",
    rotateRight: "右旋",
    photoInfo: "作品信息",
    noPhotoInfo: "暂无补充说明",
    newTab: "新窗口打开",
    loadingOriginal: "原图加载中",
    download: "保存原图",
    downloading: "下载中...",
    passcodeField: "口令",
    passcodePlaceholder: "留空保留旧口令",
    passcodeHint: "Locked 照片的分享口令；admin 可见明文",
    passcodeCopied: "口令已复制",
    passcodeNone: "—"
  },
  en: {
    siteName: "Gathered Light",
    siteSub: "拾光集",
    range: "2025 - 2026",
    issue: "Field Notebook · Personal Archive",
    headline: "Quiet hours, borrowed light, and the small ordinary in between.",
    intro: "Streets, weather, and slow afternoons of rooms, kept here to be wandered through later.",
    introLines: [
      "Streets, weather, and slow afternoons of rooms, kept here to be wandered through later.",
      "Small light, quiet pauses, and the weather of a day are saved for another afternoon."
    ],
    updated: "Updated · May 2026",
    frames: (n: number) => `${n} frames`,
    admin: "Admin",
    dashboard: "Dashboard",
    overview: "Overview",
    recentUploads: "Recent uploads",
    byPrivacy: "By privacy",
    byCategory: "By category",
    mediaQueue: "Media queue",
    navContent: "Content",
    navAccess: "Members",
    navTaxonomy: "Taxonomy",
    navSystem: "System",
    dashboardSub: "Gathered Light · content & media overview",
    photosSub: "Manage every uploaded frame",
    usersSub: "Manage accounts and roles",
    tagsSub: "Organise photo tags",
    categoriesSub: "Organise photo categories",
    appearance: "Appearance",
    appearanceSub: "Switch the public site's overall color theme",
    themeWarmName: "Warm",
    themeWarmDesc: "A warm editorial palette for a slower photo journal.",
    themeCoolName: "Cool",
    themeCoolDesc: "A restrained white interface in an Apple / Linear direction.",
    themeBoldName: "Bold",
    themeBoldDesc: "A high-contrast newsroom palette with a red accent.",
    themeApplied: (name: string) => `Switched to ${name} theme`,
    siteRangeLabel: "Site years",
    siteRangeHint: "Shown in the public footer, for example 2025 - 2026.",
    siteRangeSaved: "Site years updated",
    heroLabel: "Hero copy",
    heroHint: "The kicker, big headline and typewriter lines on the public hero, in both Chinese and English.",
    heroIssueZh: "Kicker (ZH)",
    heroIssueEn: "Kicker (EN)",
    heroHeadlineZh: "Headline (ZH)",
    heroHeadlineEn: "Headline (EN)",
    heroLinesZh: "Typewriter lines (ZH)",
    heroLinesEn: "Typewriter lines (EN)",
    heroLinesHint: "One line per row, played in a loop; up to 5 rows.",
    heroSaved: "Hero copy updated",
    welcomeBack: "Welcome back",
    viewSite: "View site",
    accountSection: "Account",
    bulkSelected: (n: number) => `${n} selected`,
    bulkDelete: "Bulk delete",
    bulkPrivacy: "Bulk privacy",
    bulkTags: "Bulk tags",
    selectAll: "Select page",
    clearSelection: "Clear",
    invertSelection: "Invert",
    appendMode: "Append",
    replaceMode: "Replace",
    bulkDeleteConfirm: (n: number) => `Delete ${n} selected photos?`,
    photos: "Photos",
    users: "Users",
    tags: "Tags",
    categoriesAdmin: "Categories",
    public: "Public",
    locked: "Locked",
    private: "Private",
    unlocked: "Unlocked",
    passcode: "Passcode",
    unlock: "Unlock",
    close: "Close",
    prev: "Previous",
    next: "Next",
    login: "Sign in",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    site: "Site",
    newPhoto: "New",
    edit: "Edit",
    recoverUrl: "Recover URL",
    recoveringUrl: "Recovering",
    recoverUrlDone: "Image URL recovered",
    delete: "Delete",
    reset: "Reset",
    repairLegacy: "Repair legacy data",
    repairLegacyDone: "Legacy data repaired",
    save: "Save",
    cancel: "Cancel",
    total: "Total",
    role: "Role",
    displayName: "Display name",
    createdAt: "Created",
    actions: "Actions",
    addTag: "New tag",
    editTag: "Edit tag",
    tagSlug: "Slug",
    tagNameZh: "Name ZH",
    tagNameEn: "Name EN",
    addCategory: "New category",
    editCategory: "Edit category",
    categorySlug: "Slug",
    categoryNameZh: "Name ZH",
    categoryNameEn: "Name EN",
    sortOrder: "Sort",
    photoCount: "Photos",
    slugChangeWarning: "Changing slug breaks old category URLs.",
    newUser: "New user",
    editUser: "Edit user",
    resetPassword: "Reset password",
    newPassword: "New password",
    owner: "Owner",
    editor: "Editor",
    viewer: "Viewer",
    title: "Title",
    slug: "Slug",
    caption: "Caption",
    altText: "Alt text",
    searchPlaceholder: "Search slug, title, location, caption",
    prevPage: "Prev",
    nextPage: "Next",
    pageOf: (page: number, total: number) => `Page ${page} / ${total}`,
    imageUrl: "Image URL",
    location: "Location",
    date: "Date",
    category: "Category",
    privacy: "Privacy",
    noFrames: "No frames",
    noTags: "No tags",
    noCategories: "No categories",
    apiSaved: "Data saved through Axum API.",
    footerNote: "A small archive of gathered light. Shared with friends; please don't repost.",
    lockedHint: "Enter the passcode shared with friends.",
    lockedPasscodeHint: "hint · 1234",
    privateTitle: "This frame is private",
    privateOnly: "This frame is private and visible to the owner only.",
    presign: "Request upload URL",
    presignReady: "Presigned URL generated",
    uploading: "Uploading...",
    uploadDone: "Uploaded",
    uploadFailed: "Upload failed",
    chooseFile: "Choose file",
    viewOriginal: "View original",
    viewFull: "View full image",
    fitToScreen: "Fit to screen",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    rotateLeft: "Rotate left",
    rotateRight: "Rotate right",
    photoInfo: "Photo info",
    noPhotoInfo: "No additional note",
    newTab: "Open in new tab",
    loadingOriginal: "Loading original",
    download: "Save",
    downloading: "Downloading...",
    passcodeField: "Passcode",
    passcodePlaceholder: "leave blank to keep current",
    passcodeHint: "Shared passcode for locked photos; visible to admin",
    passcodeCopied: "Passcode copied",
    passcodeNone: "—"
  }
} satisfies Record<Lang, Record<string, unknown>>;

export type Dictionary = typeof i18n.zh;
